module.exports = __webpack_public_path__ + "a81b5d9bd6a8791d39d546001ec8d6dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-download.png
// module id = 649
// module chunks = 61